import { orderBy } from 'lodash';
import type {
  GroupedFormOption,
  BaseFormOption,
} from 'src/components/form/form-option';
import { cn } from 'src/utils/cn';

export type SortByOptions = 'label' | 'value' | 'manual';

export function applySortBy<T extends BaseFormOption<string | null>>(
  sortBy: SortByOptions,
  options: T[]
) {
  switch (sortBy) {
    case 'manual':
      return options;
    case 'label':
      return orderBy(
        options,
        // place empty value on top, no matter what the actual label is
        [(item) => (item.value ? item.label.toLowerCase() : '')],
        ['asc']
      );
    case 'value':
      return orderBy(
        options,
        // place empty value on top, no matter what the actual label is
        [(item) => (item.value ? item.value.toLowerCase() : '')],
        ['asc']
      );
  }
}

export function applyGroupSortBy<T extends GroupedFormOption>(
  sortBy: SortByOptions,
  options: T[]
) {
  switch (sortBy) {
    case 'manual':
      return options;
    case 'label':
    case 'value': // groups have no value, so we treat it as label
      return orderBy(options, [(item) => item.label.toLowerCase()], ['asc']);
  }
}

export const selectOptionBaseClasses = cn(
  `
    rounded-xs px-lg py-sm text-label-base text-foreground-default select-none
    aria-[disabled]:cursor-not-allowed
    aria-[disabled]:bg-background-surface-disabled
    aria-[disabled]:text-foreground-surface-disabled
  `,

  `
    [[data-active-item][aria-disabled]]:outline-2
    [[data-active-item][aria-disabled]]:-outline-offset-2
    [[data-active-item][aria-disabled]]:outline-background-primary-disabled
    [[data-active-item][aria-disabled]]:hover:outline-2
    [[data-active-item][aria-disabled]]:hover:-outline-offset-2
    [[data-active-item][aria-disabled]]:hover:outline-background-primary-disabled
  `,
  // see https://github.com/ariakit/ariakit/issues/845#issuecomment-785493623
  '[pointer-events:initial]!'
);
